export default "__VITE_PUBLIC_ASSET__8846ccf9__"